/**
 * Generate VideoObject JSON-LD structured data
 * 
 * This function generates VideoObject schema markup from heroSideImage blocks in pageBuilder.
 */

interface PageBuilderBlock {
  type?: string
  typeHandle?: string
  [key: string]: any
}

/**
 * Generate VideoObject JSON-LD structured data from pageBuilder blocks
 * Currently returns a static object, will be generated dynamically from heroSideImage block
 */
export function generateVideoObjectFromHeroSideImage(pageBuilder: PageBuilderBlock[] = []): {
  '@context': string
  '@type': string
  name: string
  description: string
  thumbnailUrl: string[]
  embedUrl: string
  publisher: {
    '@type': string
    name: string
    logo: {
      '@type': string
      url: string
    }
  }
  transcript: string
} | null {

  // Find block with typeHandle === 'heroSideImage'
  const heroSideImageBlock = pageBuilder.find(block => block?.typeHandle === 'heroSideImage')

  // If block or required video asset URL is missing, don't generate schema
  const assetUrl = (heroSideImageBlock && (heroSideImageBlock['assetDesktop'] || [])[0]?.['url']) as string | undefined
  const isVideoUrl = assetUrl
    ? /\.(mp4|webm|mov|m4v|avi|ogg)(\?|#|$)/i.test(assetUrl)
    : false

  if (!heroSideImageBlock || !assetUrl || !isVideoUrl) {
    return null
  }

  const heading = (heroSideImageBlock['heading']?.['html'] || '')
    .replace(/<[^>]*>?/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 1000)

  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": heading,
    "description": heroSideImageBlock['description'],
    "thumbnailUrl": ['https://sendbird.imgix.net/cms/Homepage_-AI-agent-for-customer-service_2025-02-04-151942_sdxd.png'],
    "embedUrl": assetUrl,
    "publisher": {
      "@type": "Organization",
      "name": "Delight.ai",
      "logo": {
        "@type": "ImageObject",
        "url": "https://sendbird.imgix.net/cms/logo.svg"
      }
    },
    transcript: heroSideImageBlock['description']
  }
}

